import apiFetch from '../apiFetch'

export default function (token, customField) {
  return apiFetch({ endPoint: 'Masters/CustomField', method: 'POST', body: customField, token: token })
}
